// extracted by mini-css-extract-plugin
module.exports = {"active":"Information_active__2U4yq","informationSimple":"Information_informationSimple__b9-ar"};